import { centeredFullScreen } from 'core/styles/css';
import styled from 'styled-components';

export const LoaderContainer = styled.div`
  ${() => centeredFullScreen};
  width: 100%;
`;
